import { Component, _decorator } from 'cc';
import StateContext from './StateContext';

const { ccclass } = _decorator;

@ccclass('StateContextDependObject')
export default abstract class StateContextDependObject extends Component {
    protected context: StateContext = null;
    private _isContextEventRegistered = false;

    public attachContext(context: StateContext): void {
        if (this.context) {
            this.detachContext();
        }
        this.context = context;
        this.onContextAttach();
    }

    public detachContext(): void {
        if (!this.context) {
            return;
        }
        this.onContextDetach();
        this.context = null;
    }

    public tryRegisterContextEvents(): void {
        if (this._isContextEventRegistered) {
            return;
        }
        this.registerContextEvents();
        this._isContextEventRegistered = true;
    }

    public tryUnregisterContextEvents(): void {
        if (!this._isContextEventRegistered) {
            return;
        }
        this.unregisterContextEvents();
        this._isContextEventRegistered = false;
    }

    public abstract onContextAwake(): void;
    public abstract onContextSleep(): void;
    protected abstract registerContextEvents(): void;
    protected abstract unregisterContextEvents(): void;
    protected abstract onContextAttach(): void;
    protected abstract onContextDetach(): void;
}
